import { createAction, props } from '@ngrx/store';
import { FavoriteStop } from '../journey-planner.model';

export const getFavoriteStops = createAction('[Journey Planner]: Get favorite stops');
export const getFavoriteStopsSuccess = createAction(
    '[Journey Planner]: Get favorite stops success',
    props<{ favoriteStops: FavoriteStop[] }>()
);
export const refreshFavoriteStops = createAction('[Journey Planner] Refresh Favorite Stops');
export const addFavoriteStop = createAction(
    '[Journey Planner]: Add favorite stop',
    props<{ favoriteStop: FavoriteStop }>()
);
export const addFavoriteStopSuccess = createAction(
    '[Journey Planner]: Add favorite stop success',
    props<{ favoriteStop: FavoriteStop }>()
);
export const deleteFavoriteStops = createAction(
    '[Journey Planner]: Delete favorite stops',
    props<{ favoriteStops: FavoriteStop[] }>()
);
export const deleteFavoriteStopsSuccess = createAction(
    '[Journey Planner]: Delete favorite stops success',
    props<{ favoriteStops: FavoriteStop[] }>()
);
export const deleteFavoriteStop = createAction(
    '[Journey Planner]: Delete favorite stop',
    props<{ favoriteStop: FavoriteStop }>()
);
export const deleteFavoriteStopSuccess = createAction(
    '[Journey Planner]: Delete favorite stop success',
    props<{ favoriteStops: FavoriteStop[] }>()
);
